import ApiResource from "../../../Lib/ApiResource";

export default class UserResource extends ApiResource {

    show(id) {
        return this.get('users/'+id);
    }

    update(data) {
        return this.patch('profile', data);
    }

    updateUserAvatar(id, file) {
        let data = new FormData();
        data.append('file', file);

        return this.post('users/'+id+'/avatar', data);
    }

    updateCurrentUserAvatar(file) {
        let data = new FormData();
        data.append('file', file);

        return this.post('profile/avatar', data);
    }

    getLoggedInUser() {
        return this.get('profile');
    }

}
